export default __webpack_public_path__ + "static/media/รหัสและสถานะบัญชี.d44fda26.pdf";